module.exports = __webpack_public_path__ + "img/venueone-fdkh.0b23d859.png";